<template>
  <van-nav-bar
    title="缴费详情"
    left-arrow
    @click-left="onClickLeft"
    fixed
    placeholder
  ></van-nav-bar>

  <div class="publishDes" style="margin: 10px 28px 20px">
    <p>发布人：{{ payInfo.school_name }}</p>
    <p>缴费单编号：{{ payInfo.payment_no }}</p>

    <p>发布时间：{{ payInfo.create_time }}</p>
    <p v-if="payType > 1">缴费时间：{{ payInfo.update_time }}</p>
  </div>

  <div class="paymentDetail">
    <van-cell-group inset>
      <van-cell :value="payInfo.title" />
      <van-cell
        v-for="inf in payInfo.item"
        :key="inf.item_name"
        :title="inf.item_name"
        :value="'¥' + inf.payment"
      />
      <van-cell title="合计:" :value="'¥' + payInfo.price" />
    </van-cell-group>
  </div>
  <div v-if="payInfo.status == 1" style="margin: 60px 16px">
    <van-button
      round
      block
      type="primary"
      :loading="isPaying"
      loading-text="处理中..."
      @click="showPopup"
    >
      立即缴费
    </van-button>
  </div>
  <!-- <div  style="margin:0px 16px">
      <van-button round block type="primary" @click="goback">
        返回缴费列表
      </van-button>
    </div> -->
  <van-popup v-model:show="show" closeable position="bottom" :style="{ height: '50%' }">
    <div style="margin-top: 20px">
      <van-cell value="" />
      <van-cell title="缴费单号" :value="payInfo.payment_no" />
      <van-cell title="缴费名称" :value="payInfo.title" />
      <van-cell title="缴费金额" :value="'¥' + payInfo.price" />
    </div>

    <div style="margin: 10px 16px; margin-top: 50px">
      <van-button
        round
        block
        type="primary"
        :loading="isPaying"
        loading-text="处理中..."
        @click="toBankPay"
      >
        确认付款
      </van-button>
    </div>
  </van-popup>
  <div id="container"></div>
</template>

<script>
import { reactive, onMounted, ref } from "vue";
import { Toast } from "vant";
import { useRoute, useRouter } from "vue-router";
import api from "../service/api";

export default {
  setup() {
    const show = ref(false);
    const payType = ref(1);
    const isPaying = ref(false); // 支付流程进行中，防止重复点按钮发起多次预下单
    const Route = useRoute(); //获取值时使用
    const router = useRouter();

    const payInfo = reactive({
      item: [],
      payment_no: "",
      create_time: "",
      update_time: "",
      child_id: "",
      school_id: "",
      school_name: "",
      title: "",
      name: "",
      price: "",
      bank_type: "",
      charge_student_id: "",
      custom_id: "",
      status: 0,
    });
    const onClickLeft = () => {
      router.go(-1);
    };

    const showPopup = () => {
      show.value = true;
    };

    // 支付流程收口：关 loading + 解锁。只在流程终止（失败、取消、异常）时调用，
    // 预下单已发出、微信支付界面还在时不要调，否则用户取消支付后还能再点出一次
    const finishPay = () => {
      Toast.clear();
      isPaying.value = false;
    };

    const toBankPay = () => {
      if (isPaying.value) return;
      isPaying.value = true;
      show.value = false;
      // forbidClick 故意关掉：遮罩会挡住左上角返回，请求期间用户想退出就退不出去。
      // 防连点由 isPaying 判断 + 按钮 :loading（vant 在 loading 态不触发 click）保证
      Toast.loading({ message: "支付处理中...", forbidClick: false });
      weChatPay();
    };

    onMounted(() => {
      /* eslint-disable */
      //setTitle("缴费详情");
      onLoad();
    });

    // watch(() => {
    //   // Toast(  router.currentRoute.value.fullPath);
    //   if (router.currentRoute.value.fullPath == "/payment") {
    //     router.go(-2);
    //   }
    // });
    // let store = useStore();

    /**
     * 微信支付
     */
    const weChatPay = () => {
      api
        .weChatPay({
          openId: localStorage.getItem("openId"),
          payment_no: payInfo.payment_no,
          type: 1,
        })
        .then((res) => {
          if (res.data.code == 1001) {
            const result = res.data.result;
            if (!result) {
              finishPay();
              Toast.fail("获取支付参数失败");
              return;
            }
            if (typeof WeixinJSBridge == "undefined") {
              // 注意：监听器要包一层把支付参数传进去
              // 直接传 onBridgeReady 的话它收到的是 Event 对象，取不到 appId
              if (document.addEventListener) {
                document.addEventListener(
                  "WeixinJSBridgeReady",
                  () => onBridgeReady(result),
                  false
                );
              } else if (document.attachEvent) {
                document.attachEvent("WeixinJSBridgeReady", () => onBridgeReady(result));
                document.attachEvent("onWeixinJSBridgeReady", () =>
                  onBridgeReady(result)
                );
              }
            } else {
              onBridgeReady(result);
            }
          } else {
            finishPay();
            Toast.fail(res.data.message || "下单失败，请重试");
          }
        })
        .catch(() => {
          finishPay();
          Toast.fail("网络异常，请重试");
        });
    };
    const onLoad = () => {
      api
        .getPaymentDetail({
          charge_student_id: Route.query.charge_student_id,
        })
        .then((res) => {
          if (res.data.code == 1001) {
            payInfo.charge_student_id = res.data.result.id;
            payInfo.payment_no = res.data.result.payment_no;
            payInfo.name = res.data.result.operation;
            payInfo.create_time = res.data.result.create_at;
            payInfo.update_time = res.data.result.success_at;
            payInfo.child_id = res.data.result.student_id;
            payInfo.school_id = res.data.result.school_id;
            payInfo.title = res.data.result.charge_name;
            payInfo.price = res.data.result.payment;
            payInfo.bank_type = res.data.result.school_bank_type;
            payInfo.item = res.data.result.item;
            payInfo.custom_id = res.data.result.custom_id;
            payInfo.school_name = res.data.result.school_name;
            payInfo.status = res.data.result.status;
          } else {
            Toast(res.data.message);
          }
        })
        .catch((err) => {
          Toast(err.message);
        });
    };

    //微信支付
    function onBridgeReady(data) {
      const params = {
        appId: data.appId,
        timeStamp: String(data.timeStamp),
        nonceStr: String(data.nonceStr),
        package: data.package,
        signType: data.signType,
        paySign: data.paySign,
      };

      WeixinJSBridge.invoke("getBrandWCPayRequest", params, function (res) {
        finishPay(); //支付已有结果，无论成功失败都先解锁
        if (res.err_msg == "get_brand_wcpay_request:ok") {
          Toast("支付成功");
          router.go(-1);
        } else {
          Toast("支付失败");
        }
      });
    }

    return {
      show,
      payType,
      isPaying,
      payInfo,
      showPopup,
      toBankPay,
      onClickLeft,
      weChatPay,
    };
  },
};
</script>

<style lang="less">
.publishDes {
  display: block;
  margin-left: 10px;
  line-height: 20px;
  font-size: 14px;
  p {
    font-size: 14px;
    padding: 2px 0;
    text-align: left;

    .copy {
      color: deepskyblue;
      font-size: 14px;
    }
  }
}
</style>
